var exports = {
  "DD": "xfd349460--786cf8--title",
  "sT": "xfd349460--786cf8--promo",
  "F7": "xfd349460--786cf8--last-updated",
};

module.exports = exports;
